import styled from 'styled-components';

export const ContainerPasswordVerification = styled.div`
  * {
    color: #4d4d4d;
  }
  .title {
    display: block;

    font-size: 20px;
    font-weight: bold;
    line-height: 30px;

    margin-top: 24px;
  }

  .container-rules {
    margin-top: 24px;
    display: grid;
    grid-template-columns: repeat(2, 50%);
    gap: 24px;

    label {
      display: flex;
      align-items: center;
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      gap: 12px;
      pointer-events: none;

      input {
        width: 20px;
        height: 20px;
        border-radius: 6px;
      }
    }

    .errorValidation {
      color: #b91c1c;
    }

    @media (max-width: 768px) {
      grid-template-columns: 100%;
    }
  }
`;
